// eslint-disable-next-line @typescript-eslint/no-unused-vars -- FIXME
import $ from 'jquery'
import _ from 'underscore'
import Marionette from 'backbone.marionette'
import FormatUtils from '@/utils/formatUtils'

let SubtotalView
export default SubtotalView = (function () {
  SubtotalView = class SubtotalView extends Marionette.View {
    static initClass() {
      this.prototype.ui = {
        subtotal: '.subtotal-value',
        subtotalDiscounted: '.subtotal-value--discounted'
      }

      this.prototype.template = _.noop

      this.prototype.collectionEvents = { change: 'render' }
    }

    onRender() {
      const subtotal = this.collection.getSubtotal()
      const savingsTotal = this.collection.getSavingsTotal()

      this.ui.subtotal.text(FormatUtils.formatMoney(subtotal))
      this.ui.subtotalDiscounted.text(
        FormatUtils.formatMoney(subtotal - savingsTotal)
      )

      if (savingsTotal <= 0) {
        this.ui.subtotal.removeClass('p-price--discount')
        return this.ui.subtotalDiscounted.hide()
      } else {
        this.ui.subtotal.addClass('p-price--discount')
        return this.ui.subtotalDiscounted.show()
      }
    }
  }
  SubtotalView.initClass()
  return SubtotalView
})()
